import React, { Component } from 'react';
import { getJsonItemInvariantCase } from '../Utilities/JsonFunctions.js'
import FormExplanationValidation from './FormExplanationValidation.js';

declare var $;
declare var globalSns;

class NamezzzEdu extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }

    onChange(e, id, synonymId) {
        this.props.onChange(e, id, synonymId);
    }

    onKeyPress(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            
            if (this.props.onEnter == null) {
                return;
            }
            this.props.onEnter(e);
        }
    }

    onBlur(e) {
        this.props.onBlur(e);
    }

    componentDidMount() {
        var url = globalSns.webApiUrl + "/api/namezzz/educations/search?q=%QUERY%&seqlang=" + this.props.seqlang;
        var _this = this;

        this.$el = $(this.el);
        this.$el.val(this.props.value);
        this.$el.autocomplete({
            source: [
                 {
                     url: url,
                     type: 'remote',
                     ajax: {
                         dataType: 'json'
                     }
                 }
            ],
            valueKey: 'text',
            titleKey: 'text',
            showHint: false,
            visibleLimit: 10,
            limit: 10000,            
            replace: function( url,query ){
                if (query.length < 2) {
                    query = "";
                }
                return url.replace('%QUERY%',encodeURIComponent(query));
            }
        }).on("autocompleted.xdsoft", function(e, data) {
            _this.onChange(e, data.id, data.synonymId);
        }).on('blur', function(e) {
            var item = getJsonItemInvariantCase($(this).autocomplete("getSource")[0].xhr.responseJSON, "text", e.target.value);
            if (item != null)
                _this.onChange(e, item.id, item.synonymId);
        });
    }

    componentWillUnmount() {
        this.$el.autocomplete('destroy');
    } 

    componentDidUpdate() {
        this.$el.val(this.props.value);
    }

    render() {
        let requiredMark = this.props.required ? <span className="required-mark">*</span> : null;

        return (
            <div className="tr">
                {
                    (this.props.text) ?
                    <div className="FieldLabel td">
                        <label htmlFor={this.props.id}>{this.props.text}
                            {requiredMark}
                        </label>
                    </div> :
                    ""
                }
                <div className="EditingFormValueCell td">
                    <input type="text" id={this.props.id} disabled={this.props.disabled} ref={el => this.el = el} maxLength="200" className="form-control" onChange={this.onChange} onBlur={this.onBlur} onKeyPress={this.onKeyPress} />
                    <FormExplanationValidation id={this.props.id} explanation={this.props.explanation} showValidation={this.props.showValidation} validationText={this.props.validationText} />
                </div>
            </div>
        );
    }
}

export default NamezzzEdu;


// WEBPACK FOOTER //
// ./src/Fields/NamezzzEdu.js